import type { RouteConfig } from 'react-router-config'
// import { withAsync } from '@/components/Async'
import Blank from '@/layouts/Blank'
import subscribe from './subscribe'
import { jumpToOneclub } from '@/utils/user'

const routes: RouteConfig[] = [
  {
    path: '/account',
    component: Blank,
    routes: [
      ...subscribe,
      {
        path: '/',
        component() {
          jumpToOneclub('account', true)
          return null
        },
        // 账号资料（已迁移至oneclub，组件应该要移除的）
        // component: withAsync(() => import(/* webpackChunkName: "profile" */ '@/containers/Account/Profile')),
      },
    ],
  },
]

export default routes
